module.exports = require("uuid");


//////////////////
// WEBPACK FOOTER
// external "uuid"
// module id = 11
// module chunks = 0